const textBlocksSelectors = {
  backgroundBlocks: '.card-background.integrated-background',
  showMoreButton: '.show_more',
  cardText: '.card__text',
  showLongDescription: 'show_long_description',
};

/**
 * function to show additional content on click
 *
 * @param buttons list of DOM elements
 */
const addCustomClickAction = (buttons) => {
  buttons.forEach((b) => {
    const ancestor = b.closest(textBlocksSelectors.cardText);
    ancestor.addEventListener('click', (e) => {
      e.preventDefault();
      if (!ancestor.classList.contains(textBlocksSelectors.showLongDescription) && e.target.tagName === 'A') {
        ancestor.classList.add(textBlocksSelectors.showLongDescription);
      } else {
        ancestor.classList.remove(textBlocksSelectors.showLongDescription);
      }
    });
  });
};

/** recognise which code should be called at start */
window.addEventListener('DOMContentLoaded', () => {
  const showMoreButtons = document.querySelectorAll(`${textBlocksSelectors.backgroundBlocks} ${textBlocksSelectors.showMoreButton}`);
  if (showMoreButtons.length) {
    addCustomClickAction(showMoreButtons);
  }
});
